import React from 'react';

import { PluginSlot } from '@openedx/frontend-plugin-framework';

const UserMenuGroupItemSlot = () => (
  <PluginSlot
    id="header_user_menu_group_item_slot"
  />
);

export default UserMenuGroupItemSlot;
